import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TechSupportHistoryComponent } from './components/tech-support-history.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ChatTranscriptComponent } from './components/chat-transcript/chat-transcript.component';
import { RouterModule } from '@angular/router';
import { TechSupportHistoryListComponent } from './components/tech-support-history-list/tech-support-history-list.component';

@NgModule({
  declarations: [
    TechSupportHistoryComponent,
    ChatTranscriptComponent,
    TechSupportHistoryListComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ]
})
export class TechSupportHistoryModule { }
